import { useCallback, useState } from 'react'
import { useInterval } from './useInterval'
import DeployInfoApi, { DeployInfoType } from '../api/DeployInfoApi'

const deployInfoApi = new DeployInfoApi()

const hasUpdated = (current: DeployInfoType, previous: DeployInfoType) =>
    current.deployTime !== null && previous.deployTime !== null && current.deployTime !== previous.deployTime

const useDeployInfo = () => {
    const [clientDeployInfo, setClientDeployInfo] = useState<DeployInfoType>({
        branchName: 'unknown',
        deployTime: null,
    })
    const [hasUpdateAvailable, setHasUpdateAvailable] = useState(false)

    const fetcher = useCallback(() => {
        deployInfoApi
            .getClientDeployInfo()
            .then((deployInfo) => {
                setClientDeployInfo((previous) => {
                    setHasUpdateAvailable((hasUpdate) => {
                        if (hasUpdate) return hasUpdate

                        return hasUpdated(deployInfo, previous)
                    })
                    return deployInfo
                })
            })
            .catch((err) => console.error(err))
    }, [])

    useInterval(fetcher, 60 * 1000, true)

    return { clientDeployInfo, hasUpdateAvailable }
}

export default useDeployInfo
